import tw, { theme } from 'twin.macro';
import { useTranslation } from 'react-i18next';

import { Spacer } from '@components/Spacer';
import { Button } from '@components/Button';
import { Error } from '@icons/Error';
import { Refresh as RefreshIcon } from '@icons/Refresh';

const Container = tw.div`w-[356px] m-auto flex flex-col items-center justify-center mt-[50px]`;
const Title = tw.h3`text-[18px]`;
const SmallText = tw.span`text-[13px] text-left text-muted2 font-normal`;

export const TableDataError = (): JSX.Element => {
  const { t } = useTranslation();

  function reload() {
    window.location.reload();
  }

  return (
    <Container data-testid='table-error-fallback'>
      <Error stroke={theme`stroke.muted3`} />
      <Spacer direction='vertical' size='md' />
      <Title>{t('insights.error.title')}</Title>
      <Spacer direction='vertical' size='xs' />
      <SmallText>{t('insights.error.message')}</SmallText>
      <Spacer direction='vertical' size='md' />
      <Button.Primary
        data-testid='reload'
        role='button'
        onClick={reload}
        tw='h-[25px] w-[108px] text-[11px] flex items-center justify-center px-[10px]'>
        <RefreshIcon fill={theme`fill.btn-toggler`} tw='mr-1' />
        {t('insights.error.action')}
      </Button.Primary>
    </Container>
  );
};
